module.exports = __webpack_public_path__ + "img/activeicon-hierarchy.5203c354.svg";